import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["distance"];
import styled from 'foundations-theming/utils';
import { toShorthandSize } from '../../utils/tShirtSizes';
import { DISTANCE_SIZES } from '../../utils/distance';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHR = styled.hr.withConfig({
  displayName: "HR__StyledHR",
  componentId: "hxf9zi-0"
})(({
  $distance,
  theme,
  $cssStyles
}) => {
  return Object.assign({
    border: theme.borderWidth['0'],
    height: theme.space['25'],
    backgroundColor: theme.color['border-core-default'],
    /* Set min-height and width so that it will never be shrunk inside a flex container */
    minHeight: theme.space['25'],
    width: '100%',
    marginBlock: theme.space[DISTANCE_SIZES[toShorthandSize($distance)]]
  }, $cssStyles);
});
export const HR = _ref => {
  let {
      distance = 'md'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledHR, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $distance: distance
  }));
};